import type React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../../hooks/useAuth";
import type { AdminRouteProps } from "./types";

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
	const { user, isAuthenticated, loading } = useAuth();

	if (loading) {
		return (
			<div
				style={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					minHeight: "100vh",
					fontSize: "1.2rem",
				}}
			>
				인증 확인 중...
			</div>
		);
	}

	if (!isAuthenticated) {
		return <Navigate to="/login" replace />;
	}

	// 역할 검증 제거 - 누구나 강의자가 될 수 있으므로 접근 허용
	return <>{children}</>;
};

export default AdminRoute;
